module.exports = __webpack_public_path__ + "MI6dgjSRC-R9mVouC/agent-training-center_tips_for_success.png";